module.exports = __webpack_public_path__ + "img/35-white.e30dc811.svg";